var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 1089,
    viewBox: "0 0 660 1089",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.867 0C147.659 0 0 144.925 0 323.629C0 502.38 329.867 1088.58 329.867 1088.58C329.867 1088.58 659.756 502.38 659.756 323.629C659.756 144.925 512.004 0 329.867 0Z",
    fill: "#0E2244"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.325 523.492H286.274L312.256 467.982H332.465C335.929 485.512 361.815 512.293 374.325 523.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.899 446.071C375.769 526.707 455.158 529.336 491.245 520.571L443.61 421.238C438.318 421.725 424.557 422.406 411.855 421.238C399.152 420.069 392.127 405.169 390.203 397.865H458.044L482.583 447.532H523C495.942 391.625 462.375 299.991 453.715 304.374C402.905 370.987 312.256 388.613 273.283 389.1V446.071H346.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.283 365.727C329.581 367.193 416.188 321.909 447.941 279.541C403.198 212.349 260.296 215.271 273.283 365.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.251 221.114C304.465 224.62 274.73 261.217 271.843 263.477C264.626 260.557 250.673 250.33 244.418 244.487C250.192 225.498 305.043 187.516 316.59 188.977C318.9 190.146 323.326 210.889 325.251 221.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.823 95.4884L423.406 188.978C433.568 195.733 438.86 199.979 447.941 207.969L511.456 124.704C514.343 120.32 466.709 89.6438 463.823 95.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.171 88.1844L404.641 178.754C395.964 173.229 390.944 171 381.546 168.528L388.762 75.0373C388.762 70.6535 445.057 82.3398 442.171 88.1844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.799 165.607H358.45L365.668 73.5765C365.668 69.1927 316.59 75.0366 316.59 77.9589C324.396 112.206 332.468 165.605 336.799 165.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.051 83.8021L313.703 167.067L292.051 175.831C281.948 161.224 265.66 130.426 248.749 101.332C247.305 98.4099 290.608 80.8805 292.051 83.8021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.079 200.665L270.4 184.597L228.54 113.018C224.21 108.634 191.01 137.85 193.898 140.773L253.079 200.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.323 234.264L235.757 216.734L176.576 156.841C173.689 153.918 146.264 188.978 150.594 191.9L221.323 234.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.776 256.175L201.114 276.626L120.281 253.254C117.395 251.792 136.159 207.968 140.49 210.891L209.776 256.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.454 321.911L195.341 298.538C163.959 291.17 146.215 286.082 114.508 276.626C108.732 275.164 105.847 321.911 111.621 321.911C145.513 323.888 163.843 324.45 192.454 321.911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.454 374.499V345.284C167.663 350.106 148.592 349.683 108.734 345.284C104.402 343.821 105.848 383.262 108.734 384.724C139.047 392.026 167.737 388.676 192.454 374.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.567 402.254L108.734 412.479C105.846 413.939 105.846 456.303 108.734 456.303C146.816 455.005 164.99 447.717 189.567 418.322C193.896 413.939 195.34 400.792 189.567 402.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.463 457.764C159.087 473.058 142.908 477.598 108.734 481.137C105.846 481.137 105.845 523.492 108.734 523.492C146.642 515.01 163.584 504.508 179.463 476.754C186.679 465.066 185.235 454.841 179.463 457.764Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 417,
    height: 452,
    fill: "white",
    transform: "translate(106 72)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.07dce654cd428341bc7f6b26d3679d1b.svg";
export { ForwardRef as ReactComponent };